import React from 'react';

export default function TrendingDownIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-trending-down"><path className="secondary" d="M3.7 3.3a1 1 0 1 0-1.4 1.4l6 6a1 1 0 0 0 1.4 0L13 7.42l4.3 4.3a1 1 0 0 0 1.4-1.42l-5-5a1 1 0 0 0-1.4 0L9 8.6l-5.3-5.3z"/><path className="primary" d="M16.59 17L13 13.41l-3.3 3.3a1 1 0 0 1-1.4 0l-6-6a1 1 0 0 1 1.4-1.42L9 14.6l3.3-3.3a1 1 0 0 1 1.4 0l4.3 4.3 2.3-2.3A1 1 0 0 1 22 14v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-.7-1.7l2.29-2.3z"/></svg>
    </Tag>
  )
};
